// Module
var code = `<div class="row">
	<table class="table">
		<tr>
			<th>Date</th>
			<th>Installs</th>
			<th>1</th>
			<th>2</th>
			<th>3</th>
			<th>4</th>
			<th>5</th>
			<th>6</th>
			<th>7</th>
			<th>14</th>
			<th>30</th>
			<th>90</th>
			<th>180</th>
			<th>365</th>
		</tr>
		<tr style="background-color: #FFEBCD">
		    <td>Average</td>
		    <td>{{apply(data[0].Inst)}}</td>
		    <td>{{apply(data[0].Day_1)}}</td>
		    <td>{{apply(data[0].Day_2)}}</td>
		    <td>{{apply(data[0].Day_3)}}</td>
		    <td>{{apply(data[0].Day_4)}}</td>
		    <td>{{apply(data[0].Day_5)}}</td>
		    <td>{{apply(data[0].Day_6)}}</td>
		    <td>{{apply(data[0].Day_7)}}</td>
		    <td>{{apply(data[0].Day_14)}}</td>
		    <td>{{apply(data[0].Day_30)}}</td>
		    <td>{{apply(data[0].Day_90)}}</td>
		    <td>{{apply(data[0].Day_180)}}</td>
		    <td>{{apply(data[0].Day_365)}}</td>
		</tr>
		<tr ng-repeat="day in data.slice(1, data.length)">
		    <td>{{day.Date}}</td>
		    <td>{{day.Inst}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_1, 'Day_1')}">{{apply(day.Day_1)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_2, 'Day_2')}">{{apply(day.Day_2)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_3, 'Day_3')}">{{apply(day.Day_3)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_4, 'Day_4')}">{{apply(day.Day_4)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_5, 'Day_5')}">{{apply(day.Day_5)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_6, 'Day_6')}">{{apply(day.Day_6)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_7, 'Day_7')}">{{apply(day.Day_7)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_14, 'Day_14')}">{{apply(day.Day_14)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_30, 'Day_30')}">{{apply(day.Day_30)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_90, 'Day_90')}">{{apply(day.Day_90)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_180, 'Day_180')}">{{apply(day.Day_180)}}</td>
		    <td ng-style="{'background-color': apply_color(day.Day_365, 'Day_365')}">{{apply(day.Day_365)}}</td>
		</tr>
	</table>
</div>
`;
// Exports
module.exports = code;